"use client";

import { LandingPageRenderer } from "@/components/landing/landing-page-renderer";
import { usePublicLandingPage } from "@/hooks/use-landing-page";
import {
  DEFAULT_LANDING_CSS,
  DEFAULT_LANDING_HTML,
} from "@/lib/landing/default-content";

export function PublicLandingPage() {
  const landingQuery = usePublicLandingPage("home");
  const landing = landingQuery.data;

  return (
    <LandingPageRenderer
      title={landing?.title || "PraxisTárs"}
      html={landing?.html.trim() || DEFAULT_LANDING_HTML}
      css={landing?.css.trim() || DEFAULT_LANDING_CSS}
    />
  );
}
